import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PainelinsumoService } from '../../../../services/painelinsumo.service';
import { ToastService } from '../../../../services/toast.service';
import { EmpresaPainel } from '../../../../types/EmpresaPainel.type';
import { Perfil } from '../../../../types/Perfil.type';
import { Usuario } from '../../../../types/Usuario.type';
import { UsuarioService } from '../../clientes/usuarios/usuario.service';
import { PerfilService } from '../../perfil/perfil.service';
import {FuncaoService} from "../../../../services/funcao.service";
import {Funcao} from "../../../../types/Funcao";

@Component({
  selector: 'app-usuarioform',
  templateUrl: './usuarioform.component.html',
  styleUrl: './usuarioform.component.css',
})
export class UsuarioformComponent implements OnInit {
  loading: boolean = false;
  usuarioEnviado: boolean = false;

  perfisSelecionados: any[] = [];
  perfis: Perfil[] = [];
  usuario: Usuario = {} as Usuario;

  empresasPainelInsumo: EmpresaPainel[] = []
  empresasPainelInsumoSelecionados: any[] = [];

  funcoes: Funcao[] = [];
  funcoesSelecionadas: Funcao[] = [];
  funcoesSelecionadasOriginais: Funcao[] = [];

  carregandoFuncoes: boolean = false;

  constructor(
    private usuarioService: UsuarioService,
    private perfilService: PerfilService,
    private toastService: ToastService,
    private activatedRoute: ActivatedRoute,
    private painelInsumoService: PainelinsumoService,
    private router: Router,
    private funcaoService: FuncaoService
  ) {}

  ngOnInit() {
    let id = this.activatedRoute.snapshot.paramMap.get('id');

    this.painelInsumoService.getListEmpresasPainel().subscribe((data) => {
      this.empresasPainelInsumo = data
    })

    this.perfilService.getAll().subscribe((data) => {
      this.perfis = data;

      if (id) {
        this.usuarioService.getOne(id).subscribe((user) => {
          this.usuario = user;

          this.perfisSelecionados = this.usuario.perfis.map((m) => m.id);
          this.funcoesSelecionadas = this.usuario.funcoes;

          this.funcoesSelecionadasOriginais = [...this.funcoesSelecionadas]

          this.carregaFuncoes()

          this.painelInsumoService.getEmpresaUsuario(this.usuario.email).subscribe((data) => {

            this.empresasPainelInsumoSelecionados = data.map((m) => m.id)
          })


        });
      }
    });
  }

  salvar() {
    this.usuarioEnviado = true;

    if (
      this.usuario.nomeUsuario?.trim() &&
      this.usuario.email?.trim() &&
      this.usuario.cdUsuarioErp &&
      this.perfisSelecionados.length > 0
    ) {
      this.loading = true;

      // this.usuario.cliente = this.cliente
      this.usuario.perfis = [];
      this.perfisSelecionados.forEach((p) => {
        this.usuario.perfis.push({ id: p } as Perfil);
      });

      this.usuario.funcoes = [];
      this.usuario.funcoes = this.funcoesSelecionadas

      if (this.usuario.id) {
        this.usuarioService.put(this.usuario).subscribe({
          next: () => {

            this.painelInsumoService.postEmpresaUsuario(this.usuario.email, this.empresasPainelInsumoSelecionados).subscribe({
              next: () => {
                this.toastService.sucesso('Sucesso', 'Usuário atualizado com sucesso');

                this.loading = false;
                this.router.navigate(['administracao', 'usuarios']);
              },
              error: (erro) => {
                this.toastService.erro('Erro', 'Erro ao salvar: ' + erro.error);
                this.loading = false;
              }
            })


          },
          error: (erro) => {
            this.toastService.erro('Erro', 'Erro ao salvar: ' + erro.error);
            this.loading = false;
          },
        });
      } else {
        this.usuarioService.post(this.usuario).subscribe({
          next: () => {
            this.toastService.sucesso('Sucesso', 'Usuário salvo com sucesso');

            this.loading = false;
            this.router.navigate(['administracao', 'usuarios']);
          },
          error: (erro) => {
            this.toastService.erro('Erro', 'Erro ao salvar: ' + erro.error);
            this.loading = false;
          },
        });
      }
    }
  }

  carregaFuncoes(){

    this.carregandoFuncoes = true

    let funcoesSelecionadasTemp = this.funcoesSelecionadasOriginais.concat(this.funcoesSelecionadas)

    this.funcaoService.getFuncoesPorPerfil(this.perfisSelecionados).subscribe({
      next: (data) => {
        this.funcoes = data;

        this.funcoesSelecionadas = []

        if(funcoesSelecionadasTemp.length > 0) {
          this.funcoes.forEach(funcao => {

            if (funcoesSelecionadasTemp.filter(func => func.id == funcao.id).length > 0) {
              this.funcoesSelecionadas.push(funcao);
            }

          })
        }

        this.funcoes.sort(this.compareFuncoes);
      },
      error: (error) => {
        this.toastService.erro("Erro", "Erro ao buscar as funções: " + error.error);
      }
    })
  }

  compareFuncoes(a: Funcao, b: Funcao) {
    if(a.nomeModulo < b.nomeModulo) return -1;
    else if (a.nomeModulo > b.nomeModulo) return 1;
    else return 0;
  }

}
